import React, { useMemo, useCallback } from 'react';
import { useIspmContext } from '../../IspmContext';
import { aggregateExposuresByCategory } from '../../common';
import IspmPieWidget from '../../common/widgets/IspmPieWidget';
import { DonutChartData } from '@silverfort/sf-components/dist/Charts/DonutChart/types';
import { mapWidgetColorValuesToSeries } from '@silverfort/sf-components';
import { bigNumberToText } from '../../../../components/utils';
import { addOrRemoveIfPresentFromArray } from '../../../../utils/utils';
import { getInsightStatisticsWithoutHidden } from '../../common/get.insight.statistics.without.hidden';
import { RISK_CATEGORIES } from '@silverfort-nodelibs/common/utils/insight';

export const IspmCategoryWidget = () => {
    const { customInsightsIdsToNames, insightsData, setCategories, categories, hasUserConfigureCustomInsight } = useIspmContext();
    const onItemSelected = useCallback(
        (filterValue: string) => {
            setCategories((prevState) => addOrRemoveIfPresentFromArray(filterValue, prevState));
        },
        [setCategories]
    );

    const data = useMemo<Array<DonutChartData>>(() => {
        const insightsStatistics = getInsightStatisticsWithoutHidden(insightsData);
        const categoriesData = aggregateExposuresByCategory(insightsStatistics, customInsightsIdsToNames);
        
        if (!hasUserConfigureCustomInsight) {
            delete categoriesData[RISK_CATEGORIES.CUSTOM_INSIGHTS.key]
        }

        return Object.values(categoriesData)
            .map((category, index) => {
                const baseItem: Omit<DonutChartData, 'fill'> = {
                    formattedValue: bigNumberToText(category.total),
                    name: category.title,
                    onClick: () => onItemSelected(category.key),
                    value: category.total,
                    matchValue: category.key
                };

                const colorInfo = mapWidgetColorValuesToSeries(baseItem, index);

                return {
                    ...baseItem,
                    fill: colorInfo.fill
                } as DonutChartData;
            })
            .sort((a, b) => b.value - a.value);
    }, [insightsData, customInsightsIdsToNames, hasUserConfigureCustomInsight, onItemSelected]);

    const selectedItems: Array<string> = categories ?? [];

    return <IspmPieWidget data={data} selectedItems={selectedItems} title="Exposed Entities by Category" />;
};
